import { useSelector } from "react-redux";
import { searchAPI } from "services/apis.service";

export function CategoryService(axiosInstance) {
  const axios = axiosInstance;
  const { user } = useSelector((state) => state.auth);

  async function getCategories(userId) {
    try {
      const { data } = await axios.post(
        searchAPI.getCategories,
        {
          userId,
          includeDeletedRecords: 0,
        },
        { cache: true }
      );
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function updateCategory(categories) {
    const { data } = await axiosInstance.post(
      searchAPI.updateSidebar,
      {
        listOfCategories: categories,
      },
      { cache: false }
    );
    return data;
  }

  async function getAcademiaSearchList(userId) {
    try {
      const { data } = await axios.post(searchAPI.academiaSearchList, {
        userId,
      });
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function getDynamicCategories(search, urls) {
    const { data } = await axios.post(searchAPI.getDynamicCategories, {
      searchTerm: search,
      urls: urls,
    });
    return data;
  }

  return {
    getCategories,
    getAcademiaSearchList,
    updateCategory,
    getDynamicCategories,
  };
}
